import { useEffect, useState } from "react";
import { CommonDataTable } from "../../common-components/common-material-react-table/CommonMaterialReactTable";
import { TmmRecords } from "../../constants/tableConstants/tableHeaders";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { GrCheckboxSelected } from "react-icons/gr";
import {
  FetchTitleListRecord,
  setSelectedRowIndex,
  UpdatePagination,
  emptyTitleListPage,
  resetTitleListPage,
  titleListSortByDesc,
  RLSApi,
  emptyPreviousTitleListRecords,
} from "../../redux/reducers/TitleListreducer";
import { useNavigate } from "react-router-dom";
import {
  emptySeasonReducer,
  FetchSeason,
  UpdateSelectedSeason,
  UpdateSelectedSeasonList,
} from "../../redux/reducers/SeasonReducer";
import SelectList, { components } from "react-select";
import {
  emptyDivisionReducer,
  fetchDivision,
  UpdateSelectedDivision,
  UpdateSelectedDivisionList,
} from "../../redux/reducers/DivisionReducer";
import {
  emptyImprintReducer,
  fetchImprint,
  UpdateSelectedImprint,
  UpdateSelectedImprintList,
} from "../../redux/reducers/ImprintReducer";
import {
  fetchFormat,
  UpdateSelectedFormat,
  UpdateSelectedFormatList,
} from "../../redux/reducers/formatReducer";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import {
  addIsbnPage,
  emptyReducerStates,
  fetchIsbnList,
  removeFetchType,
  resetIsbnPage,
  setIsbnNumberOptions,
  setIsbnString,
  setIsbnTitleOptions,
  UpdateSelectedISBNS,
  UpdateSelectedISBNSList,
  UpdateSelectedTitles,
  UpdateSelectedTitlesList,
} from "../../redux/reducers/ISBNSReducer";
import Loading from "../../common-components/Loader";
import { debounceAsync, formatCurrency } from "../../common-components/commonFunctions";
import Alogo from "../../assets/images/logo.png";
import {
  emptyDetailsPageRecord,
  setDetails,resetAuthorization
} from "../../redux/reducers/DetailPageReducer";
import {
  emptyManagingEditorReducer,
  FetchManagingEditor,
  UpdatemanagingEditor,
  UpdatemanagingEditorList,
} from "../../redux/reducers/managingEditorReducer";
import {
  emptyEditorReducer,
  FetchEditor,
  UpdateEditor,
  UpdateEditorList,
} from "../../redux/reducers/editorReducer";
import {
  emptyBisacStatusReducer,
  FetchbisacStatus,
  UpdatebisacStatus,
  UpdatebisacStatusList,
} from "../../redux/reducers/BisanStatusReducer";
import {
  addPage,
  emptyAuthorReducer,
  FetchAuthor1,
  removeAuthorFetchType,
  resetAuthorPage,
  setAuthorString,
  UpdateAuthor1,
  UpdateAuthor1List,
  updateAuthorPage,
} from "../../redux/reducers/AUTHOR1Reducer";
import {
  emptyLicensorReducer,
  fetchLicensor,
  UpdateSelectedLicensor,
  UpdateSelectedLicensorList,
} from "../../redux/reducers/LicensorReducer";
import {
  emptySeriesReducer,
  fetchSeries,
  UpdateSelectedSeries,
  UpdateSelectedSeriesList,
} from "../../redux/reducers/SeriesReducer";
import MultiSelect from "../../common-components/CommonCheckBoxMultiSelect";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { MdContentCopy } from "react-icons/md";
import axios from "axios";
import { API } from "../../constants/API";
import { setresetFiltersInexport } from "../../redux/reducers/TmmExportLinkReducer";
import { user } from "../../redux/reducers/UserReducer";

interface OptionType {
  value: string;
  label: string;
}

interface FormValues {
  season: string[];
  division: string[];
  imprint: string[];
  managingEditor: string[];
  editor: string[];
  bisac_status: string[];
  format: string[];
  author: OptionType[];
  title: OptionType[];
  isbn: OptionType[];
  licensor: string[];
  series: string[];
}
const TmmMain = () => {
  const dispatch = useDispatch<AppDispatch>();
  const rawData = useSelector((state: RootState) => state.TitleListreducer.dataOfRls);

let dataofrls =
  rawData && rawData.length > 0 && rawData.some(v => v.VALUE)
    ? rawData
    : (rawData?.[0]?.COLUMN === "0" && rawData?.[0]?.VALUE === "0"
        ? rawData
        : null);

const hasStar = dataofrls?.some(v => v.VALUE === "*");

const column = hasStar ? null : dataofrls?.[0]?.COLUMN ?? null;

const value = hasStar
  ? []
  : dataofrls
  ? dataofrls
      .flatMap(v =>
        v.VALUE
          ? v.VALUE.split(",").map((str:any) => str.trim()).filter(Boolean)
          : []
      )
  : [];


    


  console.log(column,value,'valuevalue')
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const isFirefox =
    typeof navigator !== "undefined" && navigator.userAgent.includes("Firefox");
  const { control, watch, setValue } = useForm<FormValues>({
    defaultValues: {
      author: [],
      bisac_status: [],
      division: [],
      editor: [],
      format: [],
      imprint: [],
      isbn: [],
      managingEditor: [],
      season: [],
      title: [],
      licensor: [],
      series: [],
    },
  });

  //reducers

  const isbnReducer = useSelector((state: RootState) => state.isbnReducer);
  const TitleListReducer = useSelector(
    (state: RootState) => state.TitleListreducer
  );
  const [loader, setLoader] = useState(false);
  const seasonReducer = useSelector((state: RootState) => state.SeasonReducer);
  const divisionReducer = useSelector(
    (state: RootState) => state.DivisionReducer
  );
  const managingEditorReducer = useSelector(
    (state: RootState) => state.managingEditorReducer
  );
  const userData = useSelector(user);
console.log(userData?.email, "user email");

  const editorReducer = useSelector((state: RootState) => state.editorReducer);
  const bisanStatusReducer = useSelector(
    (state: RootState) => state.BisanStatusReducer
  );

  const imprintReducer = useSelector(
    (state: RootState) => state.ImprintReducer
  );
  const formatReducer = useSelector((state: RootState) => state.FormatReducer);
  const authorReducer = useSelector((state: RootState) => state.AUTHOR1Reducer);
  const licensorReducer = useSelector((state: RootState) => state.LicensorReducer);
  const seriesReducer = useSelector((state: RootState) => state.SeriesReducer);
  const selectedManagingEditors = useSelector(
    (state: RootState) => state.managingEditorReducer.managingEditor
  );
  const selectedEditors = useSelector(
    (state: RootState) => state.editorReducer.Editor
  );
  const selectedBisacStatus = useSelector(
    (state: RootState) => state.BisanStatusReducer.bisacStatus
  );
  const selectedLicensor = useSelector(
    (state: RootState) => state.LicensorReducer.selectedLicensor
  );
  const selectedSeries = useSelector(
    (state: RootState) => state.SeriesReducer.selectedSeries
  );

  const options = seasonReducer.data.map(
    (SeasonData) => SeasonData.SEASON ?? ""
  );
  const managingEditorOptions = managingEditorReducer.data.map(
    (managingEditor) => managingEditor.MANAGING_EDITOR ?? ""
  );
  const editorOptions = editorReducer.data.map((editor) => editor.EDITOR ?? "");
  const bisacStatusOptions = bisanStatusReducer.data.map(
    (bisacStatus) => bisacStatus.BISAC_STATUS ?? ""
  );
  const DivisionOption = divisionReducer.data.map(
    (Division) => Division.division ?? ""
  );
  const ImprintOption = imprintReducer.data.map((imprint) => imprint.IMPRINT);
  const FormatOption = formatReducer.data.map((format) => format.FORMAT);
  const LicensorOption = licensorReducer.data.map((licensor) => licensor.LICENSOR);
  const SeriesOption = seriesReducer.data.map((series) => series.SERIES_NAME);
  const resetFiltersInexport=useSelector((state:RootState)=>state.TmmExportLinkReducer.resetFiltersInexport)

  const authorOptions: OptionType[] = authorReducer.data
    .map((author: any) =>
      author.AUTHOR_1?.length > 1
        ? {
          value: author._id ?? "",
          label: author.AUTHOR_1 ?? "",
        }
        : undefined
    )
    .filter((option): option is OptionType => option !== undefined);

  const isbn_number_options = isbnReducer.isbns.map((isbn: any) => ({
    value: isbn._id ?? "",
    label: isbn.ISBN ?? "",
  }));

  const isbn_title_options = isbnReducer.isbns
    .map((isbn: any) => {
      if (isbn.FULL_TITLE?.length > 1) {
        return {
          value: isbn._id ?? "",
          label: isbn.FULL_TITLE ?? "",
        };
      }
      return undefined;
    })
    .filter((option): option is OptionType => option !== undefined);

  const numberOptions = isbnReducer.numberOptions

  const titleOptions = isbnReducer.titleOptions

  console.log("numberOptions",numberOptions,isbnReducer.isbns);
  useEffect(() => {
    
    if (isbnReducer.isbns?.length) {
      dispatch(setIsbnNumberOptions(isbn_number_options))

      dispatch(setIsbnTitleOptions(isbn_title_options))


    }
  }, [isbnReducer.isbns]);

  // useEffect(() => {
  //   if(isbnReducer.selectedTitlesList ){
  //     setIsbnTitleOptions([...isbn_title_options, ...titleOptions]);
  //   }
  // },[isbnReducer.selectedTitlesList])

  // Helper function to compare arrays (handles both string arrays and object arrays)
  const arraysEqual = (a: any[], b: any[]): boolean => {
    if (!a || !b) return a === b;
    if (a.length !== b.length) return false;
    // For object arrays, compare by value/label, for string arrays compare directly
    const aValues = a.map(item => typeof item === 'object' ? (item.value || item.label) : item).sort();
    const bValues = b.map(item => typeof item === 'object' ? (item.value || item.label) : item).sort();
    return aValues.every((val, idx) => val === bValues[idx]);
  };

  // it will give true if new value is selected from filters
  // Compare both length and actual values to catch all filter changes
  const currentIsbn = watch("isbn") || [];
  const currentIsbnLabels = currentIsbn.map((isbn: any) => isbn?.label || isbn);
  const currentAuthor = watch("author") || [];
  const currentAuthorLabels = currentAuthor.map((author: any) => author?.label || author);
  
  const filteredNew =
    !arraysEqual(selectedManagingEditors || [], watch("managingEditor") || []) ||
    !arraysEqual(selectedEditors || [], watch("editor") || []) ||
    !arraysEqual(selectedBisacStatus || [], watch("bisac_status") || []) ||
    !arraysEqual(authorReducer.Author1 || [], currentAuthorLabels) ||
    !arraysEqual(seasonReducer.selectedSeason || [], watch("season") || []) ||
    !arraysEqual(divisionReducer.selectedDivision || [], watch("division") || []) ||
    !arraysEqual(imprintReducer.selectedImprint || [], watch("imprint") || []) ||
    !arraysEqual(isbnReducer.selectedISBNS || [], currentIsbnLabels) ||
    !arraysEqual(formatReducer.selectedFormat || [], watch("format") || []) ||
    !arraysEqual(selectedLicensor || [], watch("licensor") || []) ||
    !arraysEqual(selectedSeries || [], watch("series") || []);
  // !authorReducer.data?.length ||
  // !seasonReducer.data?.length ||
  // !divisionReducer.data?.length ||
  // !imprintReducer.data?.length ||
  // !isbnReducer.isbns?.length ||
  // !bisanStatusReducer.data?.length ||
  // !editorReducer.data?.length ||
  // !managingEditorReducer.data?.length;

  const navigate = useNavigate();
  const bgElement = useSelector(
    (state: RootState) => state.dropdownReducer.bgElement
  );

  // this function calls data of all filters and table titles data
  const fetchAllPageData = () => {
    const seasonData = watch("season");

    const division = watch("division");

    // const feildIsbns = Array.isArray(watch("isbn"))
    //   ? watch("isbn").map((data) => data.label)
    //   : [];
      const feildIsbns=watch('isbn') ? watch('isbn').map((data)=>data.label) :[]

    const authors = Array.isArray(watch("author"))
      ? watch("author").map((data) => data.label)
      : [];

    const imprint = watch("imprint");

    const managingEditors = watch("managingEditor");
    const bisacStatus = watch("bisac_status");
    const editors = watch("editor");
    const format = watch("format");
    const licensor = watch("licensor");
    const series = watch("series");
    handleTitleListRecordsFilterFetch(true);
    dispatch(
      FetchbisacStatus({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        licensor: licensor,
        series: series,
          column:column,
        value:value
      })
    );

    dispatch(
      FetchEditor({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        licensor: licensor,
        series: series,
          column:column,
        value:value
      })
    );
    dispatch(
      FetchManagingEditor({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        licensor: licensor,
        series: series,
          column:column,
        value:value
      })
    );

    dispatch(
      fetchDivision({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        licensor: licensor,
        series: series,
          column:column,
        value:value
      })
    );
    dispatch(
      FetchSeason({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        licensor: licensor,
        series: series,
        column:column,
        value:value
      })
    );
    dispatch(
      fetchImprint({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        licensor: licensor,
        series: series,
          column:column,
        value:value
      })
    );
    dispatch(
      fetchFormat({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        licensor: licensor,
        series: series,
          column:column,
        value:value
      })
    );
    dispatch(
      fetchLicensor({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        licensor: licensor,
        series: series,
        column: column,
        value: value
      })
    );
    dispatch(
      fetchSeries({
        seasons: seasonData,
        divisions: division,
        isbns: feildIsbns,
        imprint: imprint,
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        licensor: licensor,
        series: series,
        column: column,
        value: value
      })
    );
    fetchAuthors()
    commonFetchIsbns()
  };

  // this useeffect will make buttondisabled state to false if all field are cleared from filters
  useEffect(() => {
    const isAllFieldsEmpty =
      !(seasonReducer.selectedSeasonList?.length ?? 0) &&
      !(divisionReducer.selectedDivisionList?.length ?? 0) &&
      !(imprintReducer.selectedImprintList?.length ?? 0) &&
      !(formatReducer.selectedFormatList?.length ?? 0) &&
      !(isbnReducer.selectedISBNSList?.length ?? 0) &&
      !(isbnReducer.selectedTitlesList?.length ?? 0) &&
      !(selectedManagingEditors?.length ?? 0) &&
      !(selectedEditors?.length ?? 0) &&
      !(selectedBisacStatus?.length ?? 0) &&
      !(authorReducer.Author1?.length ?? 0) &&
      !(licensorReducer.selectedLicensorList?.length ?? 0) &&
      !(seriesReducer.selectedSeriesList?.length ?? 0);
    setButtonDisabled(isAllFieldsEmpty);
  }, [
    seasonReducer.selectedSeasonList,
    divisionReducer.selectedDivisionList,
    imprintReducer.selectedImprintList,
    formatReducer.selectedFormatList,
    isbnReducer.selectedISBNSList,
    isbnReducer.selectedTitlesList,
    selectedManagingEditors,
    selectedEditors,
    selectedBisacStatus,
    authorReducer.Author1,
    licensorReducer.selectedLicensorList,
    seriesReducer.selectedSeriesList,
  ]);

  //viewer

 useEffect(() => {
  if (userData?.email) {
    dispatch(RLSApi({ email: userData?.email, report_id: "4" }));
  }
}, [dispatch, userData?.email]);

  useEffect(() => {
dispatch(resetAuthorization())
    console.log('dataofrls22',dataofrls)
    if (seasonReducer.selectedSeasonList?.length) {
      setValue("season", seasonReducer.selectedSeasonList);
    }
    if (divisionReducer.selectedDivisionList?.length) {
      setValue("division", divisionReducer.selectedDivisionList);
    }
    if (imprintReducer.selectedImprintList?.length) {
      setValue("imprint", imprintReducer.selectedImprintList);
    }

    if (formatReducer.selectedFormatList?.length) {
      setValue("format", formatReducer.selectedFormatList);
    }
    if (isbnReducer.selectedISBNSList?.length) {
      setValue("isbn", isbnReducer.selectedISBNSList);
    }

    if (isbnReducer.selectedTitlesList?.length) {
      setValue("title", isbnReducer.selectedTitlesList);
    }
    if (selectedManagingEditors?.length) {
      setValue("managingEditor", selectedManagingEditors);
    }
    if (selectedEditors?.length) {
      setValue("editor", selectedEditors);
    }
    if (selectedBisacStatus?.length) {
      setValue("bisac_status", selectedBisacStatus);
    }
    if (licensorReducer.selectedLicensorList?.length) {
      setValue("licensor", licensorReducer.selectedLicensorList);
    }
    if (seriesReducer.selectedSeriesList?.length) {
      setValue("series", seriesReducer.selectedSeriesList);
    }
    dispatch(emptyDetailsPageRecord());
          console.log('dataofrls332',dataofrls)

    if (

            value[0] !== "0" &&(

      !seasonReducer.data?.length ||
      !TitleListReducer.data?.length ||
      !isbnReducer.isbns?.length ||
      !authorReducer.data?.length ||
      !divisionReducer.data?.length ||
      !imprintReducer.data?.length ||
      !managingEditorReducer.data?.length ||
      !editorReducer.data?.length ||
      !bisanStatusReducer.data?.length)
    ){
      fetchAllPageData();

    }
    return () => {
      dispatch(resetTitleListPage());
      dispatch(resetIsbnPage());
    };
  }, [dataofrls]);

  // this function is used to clear all filters from the page
  const handleFilterClear = (e?: any) => {
    e?.preventDefault();
    setValue("season", []);
    setValue("division", []);
    setValue("imprint", []);
    setValue("isbn", []);
    setValue("title", []);
    setValue("managingEditor", []);
    setValue("editor", []);
    setValue("format", []);
    setValue("bisac_status", []);
    setValue("author", []);
    setValue("licensor", []);
    setValue("series", []);

    const TitleListIds = TitleListReducer.data.map((data) => data.EAN);
console.log(TitleListIds,'TitleListIds')
    dispatch(
      FetchTitleListRecord({
        page: TitleListReducer.page,
        limit: TitleListReducer.limit,
        season: [],
        Division: [],
        Imprint: [],
        Format: [],
        TitleListIds: TitleListIds,
        managingEditor: [],
        editors: [],
        bisacStatus: [],
        author: [],
        isbns: [],
        licensor: [],
        series: [],
        prevSeason: seasonReducer.selectedSeason,
        prevDivision: divisionReducer.selectedDivision,
        prevImprint: imprintReducer.selectedImprint,
        prevFormat: formatReducer.selectedFormat,
        prevIsbns: isbnReducer.selectedISBNS,
        prevManagingEditors: selectedManagingEditors,
        prevEditors: selectedEditors,
        prevBisacStatus: selectedBisacStatus,
        prevAuthor: authorReducer.Author1,
        prevLicensor: licensorReducer.selectedLicensor,
        prevSeries: seriesReducer.selectedSeries,
          column:column,
        value:value
      })
    );
  };
 useEffect(()=>{
    if(resetFiltersInexport){
        // alert('main')
      handleFilterClear()
    }
    dispatch(setresetFiltersInexport(false))
  },[])
  // this useffect is used to fetch next page data foof title list records
  useEffect(() => {
    if (value[0] !== "0") {
    handleTitleListRecordsFilterFetch();
    }
  }, [TitleListReducer.page, TitleListReducer.titleSortBy]);

  // this useEffect will call if there is changes in filters
  useEffect(() => {
    if (filteredNew &&  value[0] !== "0") {
      // Reset page to 1 when filters change to ensure data is replaced, not appended
      dispatch(resetTitleListPage());
      // Clear accumulated data when filters change
      dispatch(emptyPreviousTitleListRecords());
      fetchAllPageData();
    }
  }, [
    watch("season"),
    watch("division"),
    watch("imprint"),
    watch("isbn"),
    watch("author"),
    watch("bisac_status"),
    watch("editor"),
    watch("managingEditor"),
    watch("format"),
    watch("licensor"),
    watch("series"),
  ]);

  // this is used to fetch authors data
  const fetchAuthors = (fetchType?: string) => {
    const seasonData = watch("season");

    const division = watch("division");

    const feildIsbns = Array.isArray(watch("isbn"))
      ? watch("isbn").map((data) => data.value)
      : [];

    const authors = Array.isArray(watch("author"))
      ? watch("author").map((data) => data.label)
      : [];

    const imprint = watch("imprint");

    const managingEditors = watch("managingEditor");
    const bisacStatus = watch("bisac_status");
    const editors = watch("editor");
    const format = watch("format");
    const licensor = watch("licensor");
    const series = watch("series");

    dispatch(
      FetchAuthor1({
        fetchType: fetchType,
        searchStr: authorReducer.authorString,
        seasons: seasonData,
        oldEans: isbnReducer.isbns.map((isbn) => isbn.ISBN),
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        format: format,
        licensor: licensor,
        series: series,
        divisions: division,
        isbns: watch("isbn")?.length
          ? watch("isbn").map((isbn) => isbn.label)
          : [],
        imprint: imprint,
        limit: authorReducer.limit,
        page: authorReducer.page,
        selectedData: watch("author")?.length
          ? watch("author").map((author) => author.label)
          : [],
        prevSeason: seasonReducer.selectedSeason,
        prevDivision: divisionReducer.selectedDivision,
        prevImprint: imprintReducer.selectedImprint,
        prevFormat: formatReducer.selectedFormat,
        prevIsbns: isbnReducer.selectedISBNS,
        prevManagingEditors: selectedManagingEditors,
        prevEditors: selectedEditors,
        prevBisacStatus: selectedBisacStatus,
        prevAuthor: authorReducer.Author1,
          column:column,
        value:value
      })
    );
  };
  const debounceUpdateAuthorString = debounceAsync(async (searchStr) => dispatch(setAuthorString(searchStr)), 300);

  // this useffect will hit the api of authors if there is no records of authors and also if authors next data is fetched
  useEffect(() => {
    if (authorReducer.page > 1 || authorReducer.authorString?.length) {
      fetchAuthors();
      
    }
  }, [authorReducer.page, authorReducer.authorString]);

  // this useffect will hit the api of isbns if there is no records of isbns and also if isbns next data is fetched
  useEffect(() => {
    // if (isbnReducer.isbnPage > 1 || isbnReducer.isbnsString?.length) {
      commonFetchIsbns();
  // }
  },[isbnReducer.isbnPage, isbnReducer.isbnsString])

  useEffect(()=>{
    console.log(watch('isbn'),'isbnsnsnsnsn')
  },[watch('isbn')])
  const commonFetchIsbns = (type?: string) => {
    const seasonData = watch("season");
    
    const division = watch("division");

    const feildIsbns = Array.isArray(watch("isbn"))
    ? watch("isbn").map((data) => data.value)
    : [];
    
    const authors = Array.isArray(watch("author"))
      ? watch("author").map((data) => data.label)
      : [];
      
      const imprint = watch("imprint");
      
      const managingEditors = watch("managingEditor");
      const bisacStatus = watch("bisac_status");
    const editors = watch("editor");
    const format = watch("format");
    const licensor = watch("licensor");
    const series = watch("series");
    
    dispatch(
      fetchIsbnList({
        fetchType: type,
        seasons: seasonData,
        isbnString: isbnReducer.isbnsString,
        // oldEans: isbnReducer.isbns.map((isbn) => isbn._id),
        oldEans: isbnReducer.isbns.map((isbn) => isbn.ISBN),
        managingEditors: managingEditors,
        authors: authors,
        bisacStatus: bisacStatus,
        editors: editors,
        divisions: division,
        isbns: isbnReducer.isbns,
        imprint: imprint,
        format: format,
        licensor: licensor,
        series: series,
        limit: isbnReducer.isbnLimit,
        page: isbnReducer.isbnPage,
        selectedData: watch("isbn")?.length
          ? watch("isbn").map((isbn) => isbn.label)
          : [],
          prevSeason: seasonReducer.selectedSeason,
          prevDivision: divisionReducer.selectedDivision,
          prevImprint: imprintReducer.selectedImprint,
        prevFormat: formatReducer.selectedFormat,
        prevIsbns: isbnReducer.selectedISBNS,
        prevManagingEditors: selectedManagingEditors,
        prevEditors: selectedEditors,
        prevBisacStatus: selectedBisacStatus,
        prevAuthor: authorReducer.Author1,
        prevLicensor: licensorReducer.selectedLicensor,
        prevSeries: seriesReducer.selectedSeries,
          column:column,
          value:value
        })
      );
  };

  const debounceIsbnsSearchStr = debounceAsync(async(searchStr) => dispatch(setIsbnString(searchStr)), 300);


  // this have the logic of double click functionality
  let doubleClick = 0;
  const handleRowClick = (row: any, index: number) => {
    doubleClick++;
    setTimeout(() => {
      if (doubleClick === 2) {
        dispatch(setSelectedRowIndex(index));
        dispatch(setDetails(row._id));
        navigate(`/title-details/${row._id}`);
        doubleClick = 0;
      } else doubleClick = 0;
    }, 250);
  };
  
  // this useEffect sets the _id of first index title list
  useEffect(() => {
    if (
      TitleListReducer.data &&
      TitleListReducer.data.length > 0 &&
      TitleListReducer.selectedRowIndex === 0
    ) {
      dispatch(setSelectedRowIndex(0));
      dispatch(setDetails(TitleListReducer.data[0]._id));
    }
  }, [TitleListReducer.data]);
  
  // this handles the logic of isbn selected then title gets selected and vice versa
const changeIsbnInfo = (eventOrValue: any) => {
  // Detect if this came from DOM or react-select
  const isDomEvent = !!(eventOrValue && eventOrValue.target && eventOrValue.target.name);
 
  let name;
  let value;
 
  if (isDomEvent) {
    name = eventOrValue.target.name;
    value = eventOrValue.target.value;
  } else if (eventOrValue && eventOrValue._rs_name) {
    // When react-select calls changeIsbnInfo explicitly
    name = eventOrValue._rs_name;
    value = eventOrValue._rs_value;
  } else {
    name = "title";
    value = eventOrValue;
  }
 
  const isEmpty =
    value == null ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === "string" && value.trim().length === 0);

  // When one of the ISBN/TITLE fields is cleared, clear both and their option lists.
  // For other fields (e.g. AUTHOR), do NOT touch ISBN/TITLE.
  if (isEmpty) {
    if (name === "isbn" || name === "title") {
      setValue("isbn", []);
      setValue("title", []);
      dispatch(setIsbnNumberOptions([]));
      dispatch(setIsbnTitleOptions([]));
    }
    return;
  }
   // Normalize helper for consistent match
  // const normalize = (str: string = "") =>
  //   String(str).trim().toLowerCase();
 
  if (name === "title") {
    const titleIsbns = Array.isArray(value) ? value.map((t) => t.value) : [];
    console.log("DEBUG title change:", { titleIsbns, numberOptions });
 
    let isbnFilteredData =
      numberOptions?.filter((isbn) => titleIsbns.includes(isbn.value)) || [];
 console.log(isbnFilteredData,'isbnFilteredData')
    if (!isbnFilteredData.length && titleIsbns.length) {
      isbnFilteredData = titleIsbns.map((v) => ({
        value: v,
        label: v,
      }));
    }
 
    setValue("isbn", isbnFilteredData, { shouldValidate: true, shouldDirty: true });
  }
 
else if (name === "isbn") {
  const isbnsList = Array.isArray(value) ? value.map((i) => i.value) : [];

  // Find titles that correspond to selected ISBNs
  const matchedTitles =
    titleOptions?.filter((title) => isbnsList.includes(title.value)) || [];

  // Get current title values (before this change)
  const currentTitles = watch("title") || [];

  // Merge old + new without duplicates
  const mergedTitles = [
    ...matchedTitles,
    ...currentTitles.filter((ct) =>
      isbnsList.some((i) => i === ct.value)
    ),
  ];

  // Only set if something actually changed
  setValue("title", mergedTitles, { shouldValidate: true, shouldDirty: true });
}

};


  //   if (isbnIds) {
    //     const authorFilteredData =
  //       authorOptions?.filter((author) => isbnIds.includes(author.value)) || [];
  //     setValue("author", authorFilteredData);
  //   }
  // };

  // this function handles the records of table titles fetch on next page or filtering them
  useEffect(()=>{
    console.log(isbnReducer.selectedISBNS,'isbni',isbnReducer.selectedTitles, isbnReducer.selectedTitlesList,'selectedTitlesList')
  },[isbnReducer.selectedISBNS,isbnReducer.selectedTitles, isbnReducer.selectedTitlesList,])
  useEffect(() => {
  console.log("RHF watch title:", watch("title"));
}, [watch("title")]);
// Add this useEffect to monitor state changes
useEffect(() => {
  console.log('Current title value:', watch('title'));
  console.log('Current isbn value:', watch('isbn'));
  console.log('Title options:', isbn_title_options);
  console.log('ISBN options:', isbn_number_options);
}, [watch('title'), watch('isbn'), isbn_title_options, numberOptions]);
  // return

  const downloadTitleList = async (data: any) => {
    setLoader(true);
    try {
      const response = await axios.post(API.DOWNLOAD_TITLES, data, {
        responseType: "blob", // Ensure the response is treated as a binary blob
      });

      // Create a URL for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = "Book_Attributes.xlsx"; // Set the filename for the download
      document.body.appendChild(a);
      a.click(); // Trigger the download
      document.body.removeChild(a); // Clean up
      window.URL.revokeObjectURL(url); // Release the object URL
      setLoader(false);
    } catch (err: any) {
      setLoader(false);
      console.error("Error downloading file:", err);
      // Optionally, display an error message to the user
    }
  };

  const handleTitleListRecordsFilterFetch = (isFilterChange: boolean = false) => {
    const seasonData = watch("season");
    const division = watch("division");
    const isbns = watch("isbn").map((isbn)=>isbn.label);
    const imprint = watch("imprint");
    const format = watch("format");
    const licensor = watch("licensor");
    const series = watch("series");
    
    // When filters change, use empty TitleListIds to start fresh
    // When just paginating (scrolling), use TitleListIds from accumulated data to avoid duplicates
    const TitleListIds = isFilterChange || TitleListReducer.page === 1
      ? []
      : TitleListReducer.data.map((data) => data.EAN);

    const authors = Array.isArray(watch("author"))
      ? watch("author").map((data) => data.label)
      : [];

    dispatch(
      FetchTitleListRecord({
        sortBy: TitleListReducer.titleSortBy,
        // When filters change, always use page 1 to ensure data is replaced
        page: isFilterChange ? 1 : TitleListReducer.page,
        limit: TitleListReducer.limit,
        season: seasonData,
        Division: division,
        Imprint: imprint,
        format: format,
        TitleListIds: TitleListIds,
        isbns: isbns,
        managingEditor: watch("managingEditor"),
        editors: watch("editor"),
        bisacStatus: watch("bisac_status"),
        author: authors,
        licensor: licensor,
        series: series,
        prevSeason: seasonReducer.selectedSeason,
        prevDivision: divisionReducer.selectedDivision,
        prevImprint: imprintReducer.selectedImprint,
        prevIsbns: isbnReducer.selectedISBNS,
        prevManagingEditors: selectedManagingEditors,
        prevEditors: selectedEditors,
        prevBisacStatus: selectedBisacStatus,
        prevFormat: formatReducer.selectedFormat,
        prevAuthor: authorReducer.Author1,
        prevLicensor: licensorReducer.selectedLicensor,
        prevSeries: seriesReducer.selectedSeries,
          column:column,
        value:value
      })
    );

    dispatch(UpdateSelectedISBNS(isbns));
    dispatch(UpdateSelectedTitles(isbns));
    dispatch(UpdateAuthor1(authors));
    dispatch(UpdatebisacStatus(watch("bisac_status")));
    dispatch(UpdateEditor(watch("editor")));
    dispatch(UpdatemanagingEditor(watch("managingEditor")));
    dispatch(UpdateSelectedSeason(seasonData));
    dispatch(UpdateSelectedDivision(division));
    dispatch(UpdateSelectedImprint(imprint));
    dispatch(UpdateSelectedFormat(format));
    dispatch(UpdateSelectedLicensor(licensor));
    dispatch(UpdateSelectedSeries(series));

    dispatch(UpdateSelectedISBNSList(watch("isbn")));
    dispatch(UpdateAuthor1List(watch("author")));
    dispatch(UpdatebisacStatusList(watch("bisac_status")));
    dispatch(UpdateEditorList(watch("editor")));
    dispatch(UpdatemanagingEditorList(watch("managingEditor")));
    dispatch(UpdateSelectedTitlesList(watch("title")));
    dispatch(UpdateSelectedSeasonList(watch("season")));
    dispatch(UpdateSelectedDivisionList(watch("division")));
    dispatch(UpdateSelectedImprintList(watch("imprint")));
    dispatch(UpdateSelectedFormatList(watch("format")));
    dispatch(UpdateSelectedLicensorList(watch("licensor")));
    dispatch(UpdateSelectedSeriesList(watch("series")));
  };

  const tableStyles = {
    sx: {
      "& thead": {
        position: "sticky",
        top: 0,
        zIndex: bgElement ? 0 : 1,
      },
    },
  };

  // this function sets the selected value on that input with that inputs data
  const handleFilterChange = (
    selectedOptions: string[],
    selectedFilter: keyof FormValues
  ) => {
    setValue(selectedFilter, selectedOptions);
  };

  const isbnElement = document.getElementById("isbn-selector");
  const titleElement = document.getElementById("title-selector");

  useEffect(() => {
    if (isbnElement) {
      const inner_1st_Div = isbnElement.querySelector("div > div");
      // Find the inner div within the outer div

      if (inner_1st_Div) {
        const innerMostDiv = inner_1st_Div?.querySelector("div > div");
        if (innerMostDiv && innerMostDiv.scrollWidth)
          innerMostDiv.scrollLeft = innerMostDiv?.scrollWidth;
      }
    }

    if (titleElement) {
      // Find the inner div within the outer div
      const inner_1st_Div = titleElement.querySelector("div > div");

      if (inner_1st_Div) {
        const innerMostDiv = inner_1st_Div?.querySelector("div > div");
        if (innerMostDiv && innerMostDiv.scrollWidth)
          innerMostDiv.scrollLeft = innerMostDiv?.scrollWidth;
      }
    }

    // if (multiValuContainer[0] || multiValuContainer[1]) {
    //   multiValuContainer[0].scrollLeft = multiValuContainer[0].scrollWidth;
    //   multiValuContainer[1].scrollLeft = multiValuContainer[1].scrollWidth;
    // }
    // },[multiValuContainer[0]?.scrollWidth])
  }, [
    isbnElement?.querySelector("div > div")?.querySelector("div > div")
      ?.scrollWidth,
    titleElement?.querySelector("div > div")?.querySelector("div > div")
      ?.scrollWidth,
    !TitleListReducer.isLoading,
  ]);

  useEffect(() => {
    if (isbnReducer.fetchType?.length && isbnReducer.fetchType === "fetchAll" && value[0] !== "0") {
      setValue("isbn", isbn_number_options);
      setValue("title", isbn_title_options);
      dispatch(UpdateSelectedISBNSList(isbn_number_options));
      dispatch(UpdateSelectedTitlesList(isbn_title_options));
      dispatch(UpdateSelectedISBNS(isbn_number_options));
      dispatch(UpdateSelectedTitles(isbn_title_options));
      dispatch(removeFetchType());
      dispatch(setIsbnString(""));
      fetchAllPageData();
    }
  }, [isbnReducer.fetchType]);

  useEffect(() => {
    if (
      authorReducer.fetchType?.length &&
      authorReducer.fetchType === "fetchAll" && value[0] !== "0"
    ) {
      setValue("author", authorOptions);
      dispatch(UpdateAuthor1List(authorOptions));
      dispatch(UpdateAuthor1(authorOptions));
      dispatch(removeAuthorFetchType());
      dispatch(setAuthorString(""));
      fetchAllPageData();
    }
  }, [authorReducer.fetchType]);
  console.log("TitleListReducer.data", TitleListReducer.data);

  const formatDate = (dateString: string) => {
    if (!dateString) return ""; // Return empty if date is not present
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ""; // Handle invalid dates
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  function getKeyByValue(obj: any, value: any) {
    return Object.keys(obj).find((key) => obj[key] === value);
  }

  const CommonHeader = ({ column }: any) => {
    const titleKey = getKeyByValue(TmmRecords, column.columnDef.header);

     
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <span>{column.columnDef.header}</span>
        <span>
          {titleKey === TitleListReducer.titleSortBy.heading &&
            TitleListReducer.titleSortBy.sortType === "desc" ? (
            <FaSortUp
              className="cursor-pointer"
              title={`sort ${column.columnDef.header} by ascending`}
              onClick={() => {
                dispatch(
                  titleListSortByDesc({
                    sortType: "asc",
                    heading: titleKey,
                  })
                );
                dispatch(resetTitleListPage());
              }}
            />
          ) : titleKey === TitleListReducer.titleSortBy.heading &&
            TitleListReducer.titleSortBy.sortType === "asc" ? (
            <FaSortDown
              title={`sort ${column.columnDef.header} by descending`}
              className="cursor-pointer"
              onClick={() => {
                dispatch(
                  titleListSortByDesc({
                    sortType: "desc",
                    heading: titleKey,
                  })
                );
                dispatch(resetTitleListPage());
              }}
            />
          ) : (
            <FaSort
              title={`sort ${column.columnDef.header} by ascending`}
              className="cursor-pointer"
              onClick={() => {
                dispatch(
                  titleListSortByDesc({
                    sortType: "asc",
                    heading: titleKey,
                  })
                );
                dispatch(resetTitleListPage());
              }}
            />
          )}
        </span>
      </div>
    );
  };

  const handleSelectAllIsbn = () => {
    setOnMultiSearchSelect(false);

    if (isbnReducer.isbnsString?.length > 0) {
      dispatch(resetIsbnPage());
      commonFetchIsbns("fetchAll");
    }
  };

  const handleSelectAllAuthors = () => {
    setOnMultiSearchSelect(false);

    if (authorReducer.authorString?.length > 0) {
      dispatch(resetAuthorPage());
      commonFetchIsbns("fetchAll")
    }
  };

  const [onMultiSearchSelect, setOnMultiSearchSelect] =
    useState<boolean>(false);

  const customFilterOption = (
    candidate: { label: string; value: string },
    input: string
  ): boolean => {
    // Ensure input is case insensitive and check if it starts with the input
    const inputValue = input.toLowerCase();
    const candidateLabel = candidate.label.toLowerCase();
    return candidateLabel.includes(inputValue);
  };

  return (
    <Loading
      isLoading={
        TitleListReducer.isLoading ||
        isbnReducer.isLoading ||
        authorReducer.isLoading ||
        loader
      }
    >
      <div className="w-full">
        <div className="flex items-center w-full px-1 py-1 gap-2">
          <div className="flex justify-between items-center bg-gradient-to-r from-red-500 flex-1 px-3 py-2 text-[20px] font-bold text-white rounded-md">
            Title List
            <img src={Alogo} alt="" className="w-6 h-6 ml-2" />
          </div>
          <button
            disabled={loader || TitleListReducer.isLoading}
            className={`${loader || TitleListReducer.isLoading ? "bg-[#F87171]" : "bg-[#e31c23]"
              } text-white flex ${!loader && !TitleListReducer.isLoading && "hover:bg-red-700"
              } justify-center items-center
                     w-auto px-3 py-1 rounded-md cursor-pointer h-[28px] text-xs font-poppins font-semibold border border-none`}
            onClick={() => {
              const data = {
                season: watch("season"),
                Division: watch("division"),
                Imprint: watch("imprint"),
                format: watch("format"),
                isbns: watch("isbn").map((isbn: any) => isbn.label),
                managingEditor: watch("managingEditor"),
                editors: watch("editor"),
                bisacStatus: watch("bisac_status"),
                author: Array.isArray(watch("author"))
                  ? watch("author").map((data: any) => data.label)
                  : [],
                licensor: watch("licensor"),
                series: watch("series"),
                // ensure export respects the same sort the grid is using
                sortBy: TitleListReducer.titleSortBy,
                column: column,
                value: value
              };
              downloadTitleList(data);
            }}
          >
            {loader ? "Exporting..." : "Export"}
          </button>
          <button
            disabled={buttonDisabled}
            className={`${TitleListReducer.isLoading ? "bg-[#F87171]" : "bg-[#e31c23]"
              } text-white flex ${!buttonDisabled && "hover:bg-red-700"
              } justify-center items-center
                     w-auto px-3 py-1 rounded-md cursor-pointer h-[28px] text-xs font-poppins font-semibold border border-none`}
            onClick={handleFilterClear}
          >
            Clear All Filter
          </button>
        </div>
        <div className="flex flex-col p-1 w-full">
          {/* Filters Section - Top of Grid */}
          <div className={`w-full bg-gray-100 p-1.5 mb-0.5 rounded-md border border-gray-300 ${!bgElement ? "z-10" : ""} [&_.MuiInputBase-root]:h-[32px] [&_.MuiInputBase-root]:min-h-[32px] [&_.MuiInputBase-root]:max-h-[32px] [&_label]:text-xs [&_label]:mb-0.5`}>
            {/* First Row - 6 Filters */}
            <div className="grid grid-cols-6 gap-2 mb-1.5">
              <div className="w-full">
                <p className="text-[#e31c23] font-bold text-xs mb-0.5">ISBN</p>
                <Controller
                  control={control}
                  name="isbn"
                  rules={{
                    required: "ISBN is required",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref },
                  }: {
                    field: {
                      onChange: (value: OptionType[] | null) => void;
                      onBlur: () => void;
                      value: OptionType[] | null;
                      name: string;
                      ref: React.Ref<any>;
                    };
                  }) => {
                    interface OptionType {
                      value: string;
                      label: string;
                    }

                    const reorderOptions = (
                      selectedValues: OptionType[] | null | undefined,
                      options: OptionType[]
                    ): OptionType[] => {
                      if (
                        !selectedValues ||
                        selectedValues.length === 0
                      )
                        return options;
                      const uniqueSelected = Array.from(
                        new Map(
                          selectedValues.map((item) => [
                            item.value,
                            item,
                          ])
                        ).values()
                      );
                      const selectedIds = uniqueSelected.map(
                        (selected) => selected.value
                      );
                      const filteredOptions = options.filter(
                        (option) => !selectedIds.includes(option.value)
                      );
                      return [...uniqueSelected, ...filteredOptions];
                    };

                    const reorderedOptions: OptionType[] =
                      reorderOptions(value, isbn_number_options);

                    const uniqueIsbns: OptionType[] =
                      isbnReducer.selectedISBNSList
                        ? Array.from(
                          new Map(
                            isbnReducer.selectedISBNSList.map(
                              (item) => [item.value, item]
                            )
                          ).values()
                        )
                        : [];

                    return (
                      <div className="relative flex flex-col w-full">
                        <SelectList
                          filterOption={customFilterOption}
                          classNamePrefix="custom-select"
                          placeholder={"Select ISBN"}
                          onMenuScrollToBottom={() => {
                            if (isbnReducer.hasMoreIsbn) {
                              dispatch(addIsbnPage());
                            }
                          }}
                          isMulti
                          onInputChange={(value: string) => {
                            dispatch(resetIsbnPage());
                            debounceIsbnsSearchStr(value);
                          }}
                          ref={ref}
                          id="isbn-selector"
                          name={name}
                          onBlur={onBlur}
                          value={uniqueIsbns}
                          noOptionsMessage={() => "ISBN not found"}
                          components={{
                            MultiValueContainer: (props: any) => (
                              <components.MultiValueContainer
                                {...props}
                              >
                                <div className="flex">
                                  {props.children}
                                </div>
                              </components.MultiValueContainer>
                            ),
                            DropdownIndicator: () => null,
                          }}
                          className="border border-solid border-neutral-300 font-poppins rounded-lg w-full text-[14px]"
                          styles={{
                            option: (
                              provided: any,
                              state: {
                                isSelected: boolean;
                                isFocused: boolean;
                              }
                            ) => ({
                              ...provided,
                              backgroundColor:
                                state.isSelected || state.isFocused
                                  ? "#E6E6E6"
                                  : "",
                              color: state.isSelected
                                ? "black"
                                : "black",
                            }),
                            input: (provided: any) => ({
                              ...provided,
                              position: `${watch("isbn")?.length
                                ? "relative"
                                : "absolute"
                                }`,
                              left: 6,
                              marginRight: "60px",
                            }),
                            multiValue: (provided: any) => ({
                              ...provided,
                              height: "30px",
                              display: "flex",
                              alignItems: "center",
                              borderRadius: "6px",
                              minWidth: "none",
                            }),
                            menu: (provided: any) => ({
                              ...provided,
                              zIndex: 1050,
                              position: "absolute",
                              boxShadow:
                                "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            }),
                            menuPortal: (provided: any) => ({
                              ...provided,
                              zIndex: 1050,
                            }),
                            valueContainer: (provided: any) => ({
                              position: "relative",
                              maxWidth: "100%",
                              width: "100%",
                              paddingLeft: "8px",
                              paddingRight: "8px",
                              display: "flex",
                              alignItems: "center",
                              height: "32px",
                              overflowX: "auto",
                              overflowY: "hidden",
                              minWidth: "0",
                              boxSizing: "border-box",
                            }),
                            control: (provided: any) => ({
                              display: "flex",
                              height: "32px",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                              overflow: "hidden",
                            }),
                            menuList: (provided: any) => ({
                              maxHeight: "200px",
                              overflow: "hidden",
                              overflowY: "auto",
                            }),
                            clearIndicator: (provided: any) => ({
                              ...provided,
                              color: "gray",
                              cursor: "pointer",
                            }),
                          }}
                          onChange={(
                            newValue: any,
                            actionMeta: any
                          ) => {
                            const uniqueSelected: any = Array.from(
                              new Map(
                                newValue.map((item: any) => [
                                  item.value,
                                  item,
                                ])
                              ).values()
                            );
                            onChange(uniqueSelected);
                            changeIsbnInfo({ _rs_name: "isbn", _rs_value: newValue });
                          }}
                          menuPortalTarget={document.body}
                          menuPlacement="auto"
                          options={reorderedOptions}
                          hideSelectedOptions={false}
                        />
                      </div>
                    );
                  }}
                />
              </div>
              <div className="w-full">
                <p className="text-[#e31c23] font-bold text-xs mb-0.5">TITLE</p>
                <Controller
                  control={control}
                  name="title"
                  rules={{
                    required: "Title is required",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref },
                  }) => {
                    const reorderOptions = (
                      selectedValues: any,
                      options: any
                    ) => {
                      if (
                        !selectedValues ||
                        selectedValues.length === 0
                      )
                        return options;

                      const uniqueSelected = Array.from(
                        new Map(
                          selectedValues.map((item: any) => [
                            item.value,
                            item,
                          ])
                        ).values()
                      );
                      const selectedIds = uniqueSelected.map(
                        (selected: any) => selected.value
                      );
                      const filteredOptions = options.filter(
                        (option: any) =>
                          !selectedIds.includes(option.value)
                      );
                      return [...uniqueSelected, ...filteredOptions];
                    };

                    const reorderedOptions = reorderOptions(
                      value,
                      isbn_title_options
                    );

                    const uniqueTitles = isbnReducer.selectedTitlesList
                      ? Array.from(
                        new Map(
                          isbnReducer.selectedTitlesList.map(
                            (item) => [item.value, item]
                          )
                        ).values()
                      )
                      : [];

                    return (
                      <SelectList
                        filterOption={customFilterOption}
                        classNamePrefix="custom-select"
                        hideSelectedOptions={false}
                        placeholder={"Select Title"}
                        isMulti
                        onMenuScrollToBottom={() => {
                          if (isbnReducer.hasMoreIsbn) {
                            dispatch(addIsbnPage());
                          }
                        }}
                        id="title-selector"
                        ref={ref}
                        onInputChange={(value) => {
                          dispatch(resetIsbnPage());
                          if (!onMultiSearchSelect)
                            debounceIsbnsSearchStr(value);
                        }}
                        name={name}
                        onBlur={onBlur}
                        value={uniqueTitles}
                        components={{
                          MultiValueContainer: (props) => (
                            <components.MultiValueContainer {...props}>
                              <div
                                className="flex w-full"
                                onClick={() =>
                                  setOnMultiSearchSelect(false)
                                }
                              >
                                {props.children}
                              </div>
                            </components.MultiValueContainer>
                          ),
                          IndicatorsContainer: (props) => (
                            <components.IndicatorsContainer {...props}>
                              <div className="flex items-center gap-2 pr-2">
                                <div className="flex items-center ">
                                  {props.children}
                                </div>
                               
                              </div>
                            </components.IndicatorsContainer>
                          ),
                        }}
                        styles={{
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor:
                              state.isSelected || state.isFocused
                                ? "#E6E6E6"
                                : "",
                            color: state.isSelected ? "black" : "black",
                          }),
                          input: (provided) => ({
                            ...provided,
                            position: `${watch("title")?.length
                              ? "relative"
                              : "absolute"
                              }`,
                            left: 6,
                            marginRight: "60px",
                          }),
                          multiValue: (provided) => ({
                            ...provided,
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "6px",
                            minWidth: "none",
                          }),
                          valueContainer: (provided) => ({
                            position: "relative",
                            maxWidth: "100%",
                            width: "100%",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                            display: "flex",
                            alignItems: "center",
                            height: "32px",
                            overflowX: "auto",
                            overflowY: "hidden",
                            minWidth: "200px",
                            boxSizing: "border-box",
                          }),
                          control: (provided) => ({
                            display: "flex",
                            height: "32px",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            overflow: "hidden",
                          }),
                          menuList: (provided) => ({
                            maxHeight: "200px",
                            overflow: "hidden",
                            overflowY: "auto",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 1050,
                            position: "absolute",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          }),
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 1050,
                          }),
                          clearIndicator: (provided) => ({
                            ...provided,
                            color: "gray",
                            cursor: "pointer",
                          }),
                          dropdownIndicator: () => ({
                            display: "none",
                          }),
                          indicatorsContainer: (provided) => ({
                            ...provided,
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "8px",
                          }),
                        }}
                        noOptionsMessage={() => "Title not found"}
                        className="border border-solid border-neutral-200 font-poppins rounded-lg w-full text-[14px]"
                        onChange={(selectedOptions) => {
                          const uniqueSelected = Array.from(
                            new Map(
                              selectedOptions.map((item) => [
                                item.value,
                                item,
                              ])
                            ).values()
                          );
                          onChange(uniqueSelected);
                          changeIsbnInfo({ _rs_name: "title", _rs_value: selectedOptions });
                        }}
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                        options={reorderedOptions}
                      />
                    );
                  }}
                />
              </div>
              <div className="w-full">
                <p className="text-[#e31c23] font-bold text-xs mb-0.5">AUTHOR</p>
                <Controller
                  control={control}
                  name="author"
                  rules={{
                    required: "Author is required",
                  }}
                  render={({
                    field: { onChange, onBlur, value, name, ref },
                  }) => {
                    const reorderOptions = (
                      selectedValues: any,
                      options: any
                    ) => {
                      if (
                        !selectedValues ||
                        selectedValues.length === 0
                      )
                        return options;
                      const selectedIds = selectedValues.map(
                        (selected: any) => selected.value
                      );
                      const filteredOptions = options.filter(
                        (option: any) =>
                          !selectedIds.includes(option.value)
                      );
                      return [...selectedValues, ...filteredOptions];
                    };

                    const reorderedOptions = reorderOptions(
                      value,
                      authorOptions
                    );

                    return (
                      <SelectList
                        filterOption={customFilterOption}
                        classNamePrefix="custom-select"
                        placeholder={"Select Author"}
                        isMulti
                        hideSelectedOptions={false}
                        onMenuScrollToBottom={() => {
                          if (authorReducer.hasMoreAuthor) {
                            dispatch(addPage());
                          }
                        }}
                        ref={ref}
                        onInputChange={(value) => {
                          dispatch(resetAuthorPage());
                          if (!onMultiSearchSelect)
                            debounceUpdateAuthorString(value);
                        }}
                        name={name}
                        onBlur={onBlur}
                        value={value}
                        components={{
                          MultiValueContainer: (props) => (
                            <components.MultiValueContainer {...props}>
                              <div
                                className="flex w-full"
                                onClick={() =>
                                  setOnMultiSearchSelect(false)
                                }
                              >
                                {props.children}
                              </div>
                            </components.MultiValueContainer>
                          ),
                          IndicatorsContainer: (props) => (
                            <components.IndicatorsContainer {...props}>
                              <div className="flex items-center gap-2 pr-2">
                                <div className="flex items-center ">
                                  {props.children}
                                </div>
                               
                              </div>
                            </components.IndicatorsContainer>
                          ),
                        }}
                        styles={{
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor:
                              state.isSelected || state.isFocused
                                ? "#E6E6E6"
                                : "",
                            color: state.isSelected ? "black" : "black",
                          }),
                          input: (provided) => ({
                            ...provided,
                            position: `${watch("author")?.length
                              ? "relative"
                              : "absolute"
                              }`,
                            left: 6,
                            marginRight: "60px",
                          }),
                          multiValue: (provided) => ({
                            ...provided,
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "6px",
                            minWidth: "none",
                          }),
                          valueContainer: (provided) => ({
                            position: "relative",
                            maxWidth: "100%",
                            width: "100%",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                            display: "flex",
                            alignItems: "center",
                            height: "32px",
                            overflowX: "auto",
                            overflowY: "hidden",
                            minWidth: "200px",
                            boxSizing: "border-box",
                          }),
                          control: (provided) => ({
                            display: "flex",
                            height: "32px",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            overflow: "hidden",
                          }),
                          menuList: (provided) => ({
                            maxHeight: "200px",
                            overflow: "hidden",
                            overflowY: "auto",
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 1050,
                            position: "absolute",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          }),
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 1050,
                          }),
                          clearIndicator: (provided) => ({
                            ...provided,
                            color: "gray",
                            cursor: "pointer",
                          }),
                          dropdownIndicator: () => ({
                            display: "none",
                          }),
                          indicatorsContainer: (provided) => ({
                            ...provided,
                            display: "flex",
                            alignItems: "center",
                            paddingRight: "8px",
                            position: "relative",
                          }),
                        }}
                        noOptionsMessage={() => "Author not found"}
                        className="border border-solid border-neutral-200 font-poppins rounded-lg w-full text-[14px]"
                        onChange={(selectedOptions) => {
                          onChange(selectedOptions);
                          changeIsbnInfo({ _rs_name: "author", _rs_value: selectedOptions });
                        }}
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                        options={reorderedOptions}
                      />
                    );
                  }}
                />
              </div>
              <div className="w-full">
                <Controller
                  name="season"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      label="SEASON"
                      options={options}
                      selectedValues={field.value || []}
                      onChange={(value) => handleFilterChange(value, "season")}
                      placeholder="Select Season"
                    />
                  )}
                />
              </div>
              <div className="w-full">
                <Controller
                  name="division"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      label="DIVISION"
                      options={DivisionOption}
                      selectedValues={field.value || []}
                      onChange={(value) => handleFilterChange(value, "division")}
                      placeholder="Select Division"
                    />
                  )}
                />
              </div>
              <div className="w-full">
                <Controller
                  name="imprint"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      label="IMPRINT"
                      options={ImprintOption}
                      selectedValues={field.value || []}
                      onChange={(value) => handleFilterChange(value, "imprint")}
                      placeholder="Select Imprint"
                    />
                  )}
                />
              </div>
            </div>
            {/* Second Row - 6 Filters */}
            <div className="grid grid-cols-6 gap-2 mb-0">
              <div className="w-full">
                <Controller
                  name="format"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      label="FORMAT"
                      options={FormatOption}
                      selectedValues={field.value || []}
                      onChange={(value) => handleFilterChange(value, "format")}
                      placeholder="Select Format"
                    />
                  )}
                />
              </div>
              <div className="w-full">
                <Controller
                  name="managingEditor"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      label="MANAGING EDITOR"
                      options={managingEditorOptions}
                      selectedValues={field.value || []}
                      onChange={(value) =>
                        handleFilterChange(value, "managingEditor")
                      }
                      placeholder="Select Managing Editor"
                    />
                  )}
                />
              </div>
              <div className="w-full">
                <Controller
                  name="editor"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      label="EDITOR"
                      options={editorOptions}
                      selectedValues={field.value || []}
                      onChange={(value) => handleFilterChange(value, "editor")}
                      placeholder="Select Editor"
                    />
                  )}
                />
              </div>
              <div className="w-full">
                <Controller
                  name="bisac_status"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      label="BISAC STATUS"
                      options={bisacStatusOptions}
                      selectedValues={field.value || []}
                      onChange={(value) =>
                        handleFilterChange(value, "bisac_status")
                      }
                      placeholder="Select BISAC Status"
                    />
                  )}
                />
              </div>
              <div className="w-full">
                <Controller
                  name="licensor"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      label="LICENSOR"
                      options={LicensorOption}
                      selectedValues={field.value || []}
                      onChange={(value) => handleFilterChange(value, "licensor")}
                      placeholder="Select Licensor"
                    />
                  )}
                />
              </div>
              <div className="w-full">
                <Controller
                  name="series"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      label="SERIES"
                      options={SeriesOption}
                      selectedValues={field.value || []}
                      onChange={(value) => handleFilterChange(value, "series")}
                      placeholder="Select Series"
                    />
                  )}
                />
              </div>
            </div>
          </div>
          {/* Table Section */}
          <div className="font-poppins w-full">
            <CommonDataTable
              muiTableProps={tableStyles}
              tableCursor="pointer"
              maxHeight="66vh"
              hasMore={TitleListReducer.hasMore}
              enableRowStyling={true}
              FetchCallbackFun={() => {
                dispatch(UpdatePagination());
              }}
              tableHeaders={TmmRecords}
              className={` h-screen `}
              data={TitleListReducer.data}
              enableGlobalFilter={false}
              enableBottomToolbar={true}
              showRowNumbers={false}
              scrollable
              pageSize={TitleListReducer.data?.length}
              callback={(rowData, rowIndex) =>
                handleRowClick(rowData, rowIndex)
              }
              selectedIndex={TitleListReducer.selectedRowIndex}
              colSizes={[100, 100, 100, 100, 100]}
              enableTopToolbar
              changeSelectedColumnDataDesign={[
                "EAN",
                "FORMAT",
                "EBOOK_ISBN",
                "FULL_TITLE",
                "TITLEPREFIXANDTITLE",
                "SUBTITLE",
                "AMAZON_SUBTITLE",
                "SERIES_NAME",
                "US_PRICE",
                "CANADIAN_PRICE",
                "UK_PRICE",
                "AUTHOR_1",
                "TESTIMPRINTFROMHNA",
                "BISAC1_DESC",
                "SEASON",
                "BISAC_STATUS",
                "ORIGIN",
                "EDITOR",
                "MANAGING_EDITOR",
                "PARENT_ISBN",
                "PUB_DATE",
                "WAREHOUSE_DATE",
                "RELEASE_DATE",
                "GROUP_1",
                "LICENSED",
                "LICENSOR",
                // New MTD/YTD/LTD metrics after Licensor
                "MTD_Gross",
                "MTD_Return",
                "MTD_Net",
                "YTD_Gross",
                "YTD_Return",
                "YTD_Net",
                "LTD_Gross",
                "LTD_Return",
                "LTD_Net",
                "Sell_Through_Pct",
                "Indy_Usable",
                "BACKORDER_QTY",
              ]}
              changedDataCellColumn={(header, accessor) => {
                if (
                  accessor === "PUB_DATE" ||
                  accessor === "RELEASE_DATE" ||
                  accessor === "WAREHOUSE_DATE"
                ) {
                  return {
                    accessorKey: accessor,
                    header: header,
                    Cell: ({ row }: { row: any }) => (
                      <div className="text-center">
                        {row.original[accessor]?.length > 2
                          ? moment(row.original[accessor]).format("MM/DD/YYYY")
                          : " - "}
                      </div>
                    ),
                    Header: ({ column }: any) => (
                      <CommonHeader column={column} />
                    ),
                  };
                } else if (
                  accessor == "FULL_TITLE" ||
                  accessor == "TITLEPREFIXANDTITLE" ||
                  accessor === "SUBTITLE" ||
                  accessor === "AMAZON_SUBTITLE" ||
                  accessor == "BISAC1_DESC"
                )
                  return {
                    accessorKey: accessor,
                    header: header,
                    Cell: ({ row }: { row: any }) => (
                      <div className="">
                        <div className="w-[300px]  text-left">
                          {row.original[accessor]}
                        </div>
                      </div>
                    ),
                    Header: ({ column }: any) => (
                      <CommonHeader column={column} />
                    ),
                    size: 50,
                  };
                else if (
                  accessor == "SERIES_NAME" ||
                  accessor == "AUTHOR_1" ||
                  accessor === "TESTIMPRINTFROMHNA" ||
                  accessor == "BISAC_STATUS" ||
                  accessor == "EDITOR" ||
                  accessor === "MANAGING_EDITOR" ||
                  accessor === "GROUP_1"
                )
                  return {
                    accessorKey: accessor,
                    header: header,
                    Cell: ({ row }: { row: any }) => (
                      <div className="">
                        <div
                          className={`${accessor === "BISAC_STATUS"
                            ? "w-[220px]"
                            : "w-[160px]"
                            } text-left`}
                        >
                          {row.original[accessor]}
                        </div>
                      </div>
                    ),
                    Header: ({ column }: any) => (
                      <CommonHeader column={column} />
                    ),
                    size: 50,
                  };
                else if (accessor == "EBOOK_ISBN" || accessor == "EAN")
                  return {
                    accessorKey: accessor,
                    header: header,
                    Cell: ({ row }: { row: any }) => (
                      <div className="">
                        <div className="w-[130px]">
                          {row.original[accessor]}
                        </div>
                      </div>
                    ),
                    Header: ({ column }: any) => (
                      <CommonHeader column={column} />
                    ),
                    size: 50,
                  };
                else if (
                  accessor == "US_PRICE" ||
                  accessor == "CANADIAN_PRICE" ||
                  accessor == "UK_PRICE"
                ) {
                  return {
                    accessorKey: accessor,
                    header: header,
                    Cell: ({ row }: { row: any }) => {
                      return (
                        <div className="w-[130px] flex items-center justify-center">
                          {" "}
                          {formatCurrency(
                            row.original[accessor],
                            2,
                            accessor === "UK_PRICE" ? "£" : ""
                          )}{" "}
                        </div>
                      );
                    },
                    Header: ({ column }: any) => (
                      <CommonHeader column={column} />
                    ),
                    size: 50,
                  };
                } else if (
                  accessor == "LTD_Gross" ||
                  accessor == "LTD_Return" ||
                  accessor == "LTD_Net" ||
                  accessor == "MTD_Gross" ||
                  accessor == "MTD_Return" ||
                  accessor == "MTD_Net" ||
                  accessor == "YTD_Gross" ||
                  accessor == "YTD_Return" ||
                  accessor == "YTD_Net"
                ) {
                  return {
                    accessorKey: accessor,
                    header: header,
                    Cell: ({ row }: { row: any }) => {
                      const value = row.original[accessor];
                      let formattedValue = " - ";
                      if (value != null && value !== undefined && !isNaN(Number(value))) {
                        const numValue = Number(value);
                        // Format as currency with commas: $1,234,567
                        formattedValue = numValue.toLocaleString('en-US', {
                          style: 'currency',
                          currency: 'USD',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0
                        });
                      }
                      return (
                        <div className="w-[130px] flex items-center justify-center">
                          {formattedValue}
                        </div>
                      );
                    },
                    Header: ({ column }: any) => (
                      <CommonHeader column={column} />
                    ),
                    size: 50,
                  };
                } else if (accessor == "Indy_Usable" || accessor == "BACKORDER_QTY") {
                  return {
                    accessorKey: accessor,
                    header: header,
                    Cell: ({ row }: { row: any }) => {
                      const value = row.original[accessor];
                      const formattedValue = value != null && value !== undefined 
                        ? Number(value).toLocaleString('en-US', { 
                            maximumFractionDigits: 0,
                            minimumFractionDigits: 0
                          })
                        : " - ";
                      return (
                        <div className="w-[130px] flex items-center justify-center">
                          {formattedValue}
                        </div>
                      );
                    },
                    Header: ({ column }: any) => (
                      <CommonHeader column={column} />
                    ),
                    size: 50,
                  };
                } else if (accessor == "Sell_Through_Pct") {
                  return {
                    accessorKey: accessor,
                    header: header,
                    Cell: ({ row }: { row: any }) => {
                      const value = row.original[accessor];
                      const formattedValue = value != null && value !== undefined 
                        ? `${(Number(value) * 100).toFixed(2)}%`
                        : " - ";
                      return (
                        <div className="w-[130px] flex items-center justify-center">
                          {formattedValue}
                        </div>
                      );
                    },
                    Header: ({ column }: any) => (
                      <CommonHeader column={column} />
                    ),
                    size: 50,
                  };
                }
                return {
                  accessorKey: accessor,
                  header: header,
                  Cell: ({ row }: { row: any }) => (
                    <div className="w-[150px]">
                      <div className=" text-center ">
                        {row.original[accessor]}
                      </div>
                    </div>
                  ),
                  Header: ({ column }: any) => <CommonHeader column={column} />,
                  size: 50,
                };
              }}
              topToolbar={({ table }) => (
                <div></div>
              )}
            />
          </div>
        </div>
      </div>
    </Loading>
  );
};

export default TmmMain;
